import { createTheme } from '@mui/material/styles';

import { colors } from 'constants-colors';

export default createTheme({
  palette: {
    primary: {
      main: colors.darkGreen,
    },
    secondary: {
      main: colors.errorOLD,
    },
    success: {
      main: colors.accent,
    },
  },
  typography: {
    fontFamily: ['Inter', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
});
